import script from "./CustomResourceApplySG.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomResourceApplySG.vue?vue&type=script&setup=true&lang=ts"

import "./CustomResourceApplySG.vue?vue&type=style&index=0&id=71b6d7dd&lang=less&scope=true"

const __exports__ = script;

export default __exports__